import { render } from "./NotFound.vue?vue&type=template&id=14cd0c05&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=14cd0c05&scoped=true&lang=css"

import exportComponent from "/home/runner/work/portfolio/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14cd0c05"]])

export default __exports__